module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"IP":"IP"},"de":{"IP":"IP"}}')
  delete Component.options._Ctor
}
